import React from 'react' // eslint-disable-line

import DatesRatesLinks from '../DatesRatesLinks'

export default () => <DatesRatesLinks />
